@let isDesktop = deviceService.isDesktop$ | async;

<style>
  .x-mobile-file-tabs {
    overflow-x: auto !important;
    height: 46px;
    box-shadow: none;
    button.x-mobile-file-tab-button {
      color: #49454f;
      font-weight: 500;
      padding: 14px !important;
      border-radius: 26px;
      margin-left: 0;
      &.active-tab {
        background-color: #f4f4f4;
        font-weight: 700;
      }
    }
  }
</style>

<div
  class="x-card x-card_size_m md:container md:mx-auto md:w-1/2 mt-4.5 x-white card-shadow"
>
  @if (isDesktop) {
    <tui-tabs [(activeItemIndex)]="tabIndex" class="overflow-x-auto! mb-10">
      @for (tab of tabs; track tab) {
        <button
          tuiTab
          routerLinkActive="font-bold"
          [routerLink]="[tab]"
          replaceUrl="true"
          class="mx-2 p-1! h-[40px]!"
        >
          {{
            'request_form.tabs.' + RequestFormFilesTabTitlesTranslateKeys[tab]
              | translate
          }}
        </button>
      }
    </tui-tabs>
  } @else {
    <tui-tabs
      [(activeItemIndex)]="tabIndex"
      class="x-mobile-file-tabs mb-10"
      underline="transparent"
    >
      @for (tab of tabs; track tab) {
        <button
          tuiTab
          routerLinkActive="active-tab"
          [routerLink]="[tab]"
          replaceUrl="true"
          class="x-mobile-file-tab-button typo-body-s"
        >
          {{
            'request_form.tabs.' + RequestFormFilesTabTitlesTranslateKeys[tab]
              | translate
          }}
        </button>
      }
    </tui-tabs>
  }

  <router-outlet></router-outlet>
</div>
